module.exports = __webpack_public_path__ + "static/media/KnK.4bb316c0.png";